import React,{useEffect,useContext,useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Tooltip, IconButton, Select, FormControl, InputLabel,
  TextField
} from '@material-ui/core'
import Reporte from './Reporte'
import ReporteSN from './ReporteSNDatos'
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Reloj from './Reloj';
import LinearProgress from '@material-ui/core/LinearProgress';
import {findNumber} from '../funciones/FindNumber'
import {llamadaApiToken,ErrorGeneral , llamaApiCargaToken } from '../funciones/ClienteAxios';
import SearchIcon from '@material-ui/icons/Search';
import { DatePicker,MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";

const useStyles = makeStyles((theme) => ({
    root: {      
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      
    },
  }));

const Relojes2 = ({fechas,setFechas,opcionBit}) => {    
  const {inicio,final}=fechas  
  const guardarInicio = auxF =>
  {
    setFechas({...fechas, inicio : auxF })
  };  
  
  const guardarFinal = auxF =>
  {
    setFechas({...fechas, final : auxF })
  };

  return (
  <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>  
  <Box display={"flex"} flexDirection={"column"}> 
    <Box component="span"  >
      <Tooltip title="Seleccionar Fecha" >                
        <DatePicker
          disableFuture   format="dd/MM/yyyy"
          views={["year", "month", "date"]}
          label="Fecha Inicial" size="small"
          minDate="2023-03-31" maxDate={new Date()}
          value={inicio} onChange={guardarInicio}            
          style={{width:7+'rem'}} cancelLabel={"Cancelar"}                  
          okLabel="Seleccionar" 
        />                           
      </Tooltip>                                   
    </Box>  
   {opcionBit!=="dia"?
    <Box   component="span" width="25%">
      <DatePicker
        disableFuture id="final"
        format="dd/MM/yyyy" label="Fecha Final"
        views={["year", "month", "date"]}
        minDate={inicio} maxDate={new Date()}
        value={final} name="final"
        size="small" style={{width:6.5+'rem'}}      
        cancelLabel={"Cancelar"} okLabel="Seleccionar"    
        onChange={guardarFinal}
        minDateMessage={"La fecha final debe ser menor a Fecha inicial"}
      />
    </Box>
    :null}                  
    </Box> 
  </MuiPickersUtilsProvider>
  );
}

const RepoIncidencias = () => {
  const history = useHistory();
  const usu= localStorage.getItem('UsuarioNom');
  const nvl= localStorage.getItem('Tipo');     
  const idusu = localStorage.getItem('UsuId');       
  const source = axios.CancelToken.source();  
  const classes = useStyles();
  const [datos,setDatos]=useState([])
  const [espera,setEspera]=useState(false)  
  const {usuario,guardarUsuario}=useContext(AuthContext);
  const {guardarGenerales}=useContext(GeneralesContext);    
  const [fechas,setFechas]=useState({inicio:new Date(),final:new Date()})
  const [buscar,setBuscar]=useState(false)
  const [listStatus, setListStatus] = useState([])  
  const [listTipo, setListTipo] = useState([])  
  const [filtro, setFiltro] = useState({estatus:0, tipo:0,cadena:"" })  
  const {estatus, tipo, cadena}=filtro
  const {inicio, final}=fechas

  useEffect(()=>{               
   
    veriSesion()
    if (listStatus.length === 0 ) {
      getListStatus()
    }

    if (listTipo.length === 0 ) {
      getListTipo()
    }

    datosBitacora()    
    return ()=> {
      source.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[buscar])

  const veriSesion =  () => 
  {            
    if(usu===null)
    {                                
      guardarUsuario([])						
      guardarGenerales([])     
      localStorage.clear();           
      history.push("/")	
    }
    else
    { 
      if (usuario.length === 0) 
      {
        guardarUsuario({Nombre:usu,nivel:nvl});                                      
      }
      guardarGenerales({Titulo:'Reporte Incidencia'})                     
    }
  }

  const datosBitacora=()=>{
     
    const fInicio=moment(inicio).format("YYYY-MM-DD")                
    const fFin=moment(final).format("YYYY-MM-DD")   
    const data = qs.stringify({    
      Usuario:idusu,
      Tipo:tipo!=="" ? tipo : "",
      Status:estatus!=="" ? estatus : "",
      Cadena:cadena,
      fechaIni:fInicio+'T00:00:00' ,
      fechaFin:fFin+'T23:59:59',                                  
      ip:"127.0.0.0",
      idDispositivo:'ifrekvjkxcdwdcwe'
    });
    const url = "/maquinaria/rep/incidencia/rango";
    function respuesta(aux) {
      if (aux[0].length!==0) 
      {                
        setDatos(aux[0]);                                      
      }          
    }

    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  }
 
  const getListStatus = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/status";
  
    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {          
        let nvoArr=[]
        aux.forEach(element => {
          if (element.Id===0) {
          nvoArr.push({...element,Descr:"Todos"})  
          }else{
            nvoArr.push(element)  
          }
          
        });       
        setListStatus(nvoArr);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };  
  
  const getListTipo = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/tipo";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {       
        let nvoArr=[]
        aux.forEach(element => {
          if (element.Id===0) {
          nvoArr.push({...element,Descr:"Todos"})  
          }else{
            nvoArr.push(element)  
          }
          
        });                  
        setListTipo(nvoArr);                                      
      }         
    }
    llamadaApiToken(data, url,respuesta,ErrorGeneral,history,source);
  };  

  const incrementarBuscar = e =>
  {      
    setBuscar(!buscar)              
  };

  const onChangeSelect = e =>
  {
    setFiltro({ ...filtro, [e.target.name] : e.target.value })
  };

  
  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setFiltro({ ...filtro, [e.target.name] : e.target.value  })
      
    }
  };

  function verificaReporte(auxJson){
    let auxValido=false;
    if (auxJson?.terminal !== undefined && auxJson.terminal[0].paros) {
      auxValido=true;
    //console.log('no esta vacio');
    } 
    else 
    {
      auxValido=false;
      //console.log('si esta vacio');
    }
    return auxValido;
  }

  return (
  <div>            
    <Box display="flex" flexDirection="row">
      <Box display="flex" width="25%" flexDirection="column">
        <Relojes2 fechas={fechas} setFechas ={setFechas } />  
       
        {listStatus.length!==0 ?  
        <Box display="flex" flexDirection="row" mr={2}>        
          <FormControl className={classes.formControl} size="small" style={{width:12+'rem'}}>
            <InputLabel htmlFor="age-native-simple">Estatus</InputLabel>
            <Select
              native value={estatus}  onChange={onChangeSelect}
              inputProps={{ name: 'estatus', id: 'estatus', }}            
            >
              <option aria-label="None" value="" />      
              {listStatus.map((row) => (
                  <option value={row.Id}>{row.Descr}</option>
              ))}   
            </Select>
          </FormControl>             
        </Box> 
        :<LinearProgress color="primary" />}    
        {listTipo.length!==0 ?  
        <Box display="flex" flexDirection="row">        
          <FormControl className={classes.formControl} size="small" style={{width:12+'rem'}}>
            <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
            <Select
              native value={tipo}  onChange={onChangeSelect}
              inputProps={{ name: 'tipo', id: 'tipo', }}            
            >
              <option aria-label="None" value="" />      
              {listTipo.map((row) => (
                  <option value={row.Id}>{row.Descr}</option>
              ))}   
            </Select>
          </FormControl>             
        </Box> 
        :null}      
        <TextField id="outlinedReferen"           
          label="Filtro"  size="small"
          value={cadena} onChange={onChangeRef}  
          name="cadena" style={{width:9+'rem'}}                                               
        /> 
        <Box style={{ marginLeft:".5rem"}} display="flex" justifyContent="center">    
          <Tooltip title="Buscar reporte" >                          
            <IconButton color="inherit"  aria-label="add circle" 
              component="span" onClick={incrementarBuscar} 
            >
              <SearchIcon color="primary" style={{ fontSize: 40 }}  />
            </IconButton>            
          </Tooltip>  
        </Box>    
      </Box>
      <Box display="flex" width="75%" >
        { !espera ? 
          datos.length !== 0 ?  ( verificaReporte(datos) ?
            <Reporte urlReport={"reports/Reporte-Incidencia251102.mrt"} informacion={datos}
              nombre={' Reporte Incidencia'} mostrarTB={true}
            />
          :<span>{<ReporteSN urlReport={"reports/Reporte-Incidencia251102.mrt"} informacion={datos}
              nombre={' Reporte Incidencia'} mostrarTB={true}
            />/*   */ } </span>
            ) :<Reporte urlReport={"reports/Reporte-Incidencia251102.mrt"} informacion={datos}
            nombre={' Reporte Incidencia'} mostrarTB={true}
          />
          :
          <Box style={{width:'100%'}} pt={2}>
            <LinearProgress color="primary" /> 
          </Box>
        }                
      </Box>
    </Box>                        
  </div>
  )
}

export default RepoIncidencias